import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Typography,
  Tab,
  Tabs,
  Checkbox,
  Switch,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchBar2 from "../../components/SearchBar2";
import Pagination from "../../components/Pagination";
// import WarnModal from "../../components/WarnModal";
import { isValidInput } from "../../utils/validation";
import WarnModal from "../../components/WarnModal";
import {
  useGetAllProductCountMutation,
  useProductListMutation,
  useUpdateBestProductsMutation,
  useUpdateProductApprovalStatusMutation,
} from "../../services/products";
import { errorToast, successToast } from "../../helpers";
import { ProductType } from "../../types/General";
import {
  useLazyAllCategoryQuery,
  useLazyAllSubcategoriesQuery,
} from "../../services/main";
import { RejectModal } from "../../components";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import Loader from "../../helpers/constants/Loader";
import {
  usePutChangeProductStatusMutation,
  usePutChangeUserStatusMutation,
} from "../../services/registration";
import { getFromStorage } from "../../constants/storage";
import { STORAGE_KEYS } from "../../constants/storageKeys";
import useTranslation from "../../hooks/Translation";
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const ManageProduct = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const currency = getFromStorage(STORAGE_KEYS.currency);
  const [getCount] = useGetAllProductCountMutation();
  const [value, setValue] = React.useState(0);
  const [loading, setIsLoading] = useState(false);
  const [productsData, setProductsData] = useState<ProductType[]>([]);
  const [getProductsList] = useProductListMutation();
  const [approvalStatus] = useUpdateProductApprovalStatusMutation();
  const [totalRecords, setTotalRecords] = useState(10);
  const [limit, setLimit] = useState<number>(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState<string>("");
  const [page, setPage] = useState(1);
  const [setBestProduct] = useUpdateBestProductsMutation();
  const [putChangeUserStatus] = usePutChangeProductStatusMutation();
  const [productCount, setProductCount] = useState<any>("");
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<any | null>(null);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [categoryData, setCategoryData] = useState([]);
  const [subCatData, setSubCatData] = useState([]);
  const [selectedSubCat, setSelectedSubCat] = useState<string>("");
  const [totalPages, setTotalPages] = useState(1);
  const [selectedProductId, setSelectedProductId] = useState<
    number | undefined
  >();
  const [rejectOpen, setRejectOpen] = useState(false);

  const [getCategory] = useLazyAllCategoryQuery();
  const [getSubcategory] = useLazyAllSubcategoriesQuery();

  const getCategoryDetail = async () => {
    try {
      const res = await getCategory({}).unwrap();
      if (res?.status === 200) {
        setCategoryData(res?.data);
      }
    } catch (error: any) {
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  const getProductCount = async () => {
    const body = {
      search: debouncedSearchTerm,
    };
    try {
      const res = await getCount(body).unwrap();
      if (res?.status === 200) {
        setProductCount(res?.data);
      }
    } catch (error: any) {
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  const handleCategoryChange = (e: any) => {
    setFilter(e.target.value);
    setSelectedSubCat("");
    getSubCat(e.target.value);
  };

  const getSubCat = async (id: number) => {
    try {
      const res = await getSubcategory({ id }).unwrap();
      if (res?.status === 200) {
        setSubCatData(res?.data);
      }
    } catch (error: any) {
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  const fetchData = async (page: number, search: string) => {
    setIsLoading(true);
    const body = {
      start: page,
      search: searchTerm,
      length: limit,
      status: value === 0 ? 3 : value === 1 ? 1 : 2,
      ...(filter ? { category: Number(filter) } : {}),
      ...(selectedSubCat ? { sub_category: Number(selectedSubCat) } : {}),
    };

    try {
      const response = await getProductsList({
        body,
      }).unwrap();
      if (response.status === 200) {
        setIsLoading(false);
        setProductsData(response?.data?.response_object);
        setTotalRecords(response?.data?.total_records);
        setTotalPages(Math.ceil(response?.data?.total_records / limit));
      } else {
        setProductsData([]);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const ApproveReject = async (id: any, status: number) => {
    setIsLoading(true);

    try {
      const response = await approvalStatus({
        id,
        status: status,
      }).unwrap();

      if (response.status === 200) {
        successToast(response?.message || "");
        // toast.success("User approval status updated successfully!");
        fetchData(page, debouncedSearchTerm);
        getProductCount();
      } else {
        // toast.error("Failed to update approval status. Please try again.");
      }
    } catch (error: any) {
      console.error("Error updating approval status:", error);
      errorToast(error?.message || "Failed to update approval status");
      // toast.error("An error occurred while updating approval status.");
    } finally {
      setIsLoading(false);
    }
  };
  const changeUserStatus = async (id: string | number, is_active: boolean) => {
    try {
      const response = await putChangeUserStatus({
        id,
        is_active: is_active,
      }).unwrap();

      if (response?.status === 200) {
        if (is_active === false) {
          successToast("Product Activated Successfully");
        } else {
          successToast("Product Deactivated Successfully");
        }
        fetchData(page, searchTerm);
      }
    } catch (error: any) {
      console.error("Error updating status:", error);
    }
  };
  const updateBestProduct = async (
    id: number,
    status: boolean,
    type: number
  ) => {
    console.log(id, status);
    let body1 = {
      today_deal: status,
    };

    let body2 = {
      daily_best_product: status,
    };

    const response = await setBestProduct({
      id,
      body: type === 1 ? body1 : body2,
    }).unwrap();
    if (response?.status === 200) {
      const updatedData = productsData?.map((x: any) => {
        if (x?.id === id) {
          return {
            ...x,
            ...(type === 1
              ? { today_deal: status }
              : { daily_best_product: status }),
          };
        }
        return x;
      });
      setProductsData(updatedData);
      successToast(
        type === 1
          ? "Today Deals updated successfully"
          : "Best Deals updated successfully"
      );
    } else {
      errorToast("Please try again");
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPage(1);
  };

  useEffect(() => {
    fetchData(page, debouncedSearchTerm);
  }, [page, debouncedSearchTerm, limit, value, filter, selectedSubCat]);

  useEffect(() => {
    getCategoryDetail();
  }, []);

  useEffect(() => {
    getProductCount();
  }, [debouncedSearchTerm]);

  return (
    <div>
      <Loader isLoad={loading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.sideBar.manageProducts}</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <div className="cards_header_right">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
              <Box className="cards_header_right"></Box>
              <Box>
                <Select
                  className="childFilter"
                  value={filter}
                  onChange={(e) => handleCategoryChange(e)}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    {t.main.selectCategory}
                  </MenuItem>
                  {categoryData?.map((cat: any) => (
                    <MenuItem key={cat?.id} value={cat?.id}>
                      {cat?.category_name || ""}
                    </MenuItem>
                  ))}
                </Select>
                {/* <div style={{ margin: 10 }}></div> */}
                <Select
                  className="childFilter"
                  value={selectedSubCat}
                  onChange={(e) => setSelectedSubCat(e.target.value)}
                  displayEmpty
                  disabled={!filter}
                  sx={{ marginLeft: 2 }}
                >
                  <MenuItem value="" disabled>
                    {t.main.selectSubCategory}
                  </MenuItem>
                  {subCatData?.map((cat: any) => (
                    <MenuItem key={cat?.id} value={cat?.id}>
                      {cat?.sub_category_name || ""}
                    </MenuItem>
                  ))}
                </Select>
                {filter !== "" ? (
                  <Button
                    className="btn btn_primary"
                    style={{ backgroundColor: "black", marginLeft: 10 }}
                    onClick={() => {
                      setFilter("");
                      setSelectedSubCat("");
                    }}
                  >
                    {t.main.clearFilter}
                  </Button>
                ) : (
                  ""
                )}
              </Box>
            </div>

            <Box className="cards_header_right">
              <Button
                className="btn btn_primary"
                onClick={() => navigate("/manage-products/add")}
              >
                <AddIcon />
                {t.main.addProduct}
              </Button>
            </Box>
          </Box>
          <div style={{ margin: 20 }}></div>
          <Box className="custom_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab
                label={`${t.main.pending}${productCount?.PENDING ? ` (${productCount?.PENDING})` : ""}`}
                {...a11yProps(0)}
              />
              <Tab
                label={`${t.main.approved}${productCount?.ACCEPT ? ` (${productCount?.ACCEPT})` : ""}`}
                {...a11yProps(1)}
              />
              <Tab
                label={`${t.main.rejected}${productCount?.REJECT ? ` (${productCount?.REJECT})` : ""}`}
                {...a11yProps(2)}
              />
            </Tabs>

            <CustomTabPanel value={value} index={0}>
              <TableContainer className="table_container">
                <Table sx={{ minWidth: 650 }} aria-label="sub-category table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      <TableCell>{t.main.image}</TableCell>
                      <TableCell>{t.main.productName}</TableCell>
                      <TableCell>{t.main.vendorName}</TableCell>
                      <TableCell>{t.main.subCategoryName}</TableCell>
                      <TableCell>{t.main.parentCategory}</TableCell>
                      <TableCell>{t.main.manageProduct}</TableCell>
                      <TableCell>{t.main.actions}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {productsData?.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                          {t.error.noData}
                        </TableCell>
                      </TableRow>
                    ) : (
                      productsData?.map((item, index) => (
                        <TableRow key={item?.id}>
                          <TableCell align="center">
                            {(page - 1) * limit + index + 1}
                          </TableCell>
                          <TableCell>
                            <img
                              style={{
                                borderRadius: "50%",
                                width: 50,
                                height: 50,
                              }}
                              src={item?.product_image?.[0]?.media_url}
                              alt={""}
                            />
                          </TableCell>
                          <TableCell>{item?.product_name || ""}</TableCell>
                          <TableCell>{item?.company_name || ""}</TableCell>
                          <TableCell>{item?.sub_category || ""}</TableCell>
                          <TableCell>{item?.category || ""}</TableCell>
                          <TableCell>
                            {
                              <div
                                style={{
                                  justifyContent: "space-evenly",
                                  display: "flex",
                                }}
                              >
                                <Button
                                  value="Reject"
                                  onClick={() => {
                                    setSelectedProductId(item?.id);
                                    setRejectOpen(true);
                                  }}
                                  style={{
                                    backgroundColor: "red",
                                    width: 90,
                                    height: 40,
                                    color: "white",
                                  }}
                                >
                                  {t.main.reject}
                                </Button>
                                <div style={{ margin: 8 }}></div>
                                <Button
                                  value="Approve"
                                  onClick={() => ApproveReject(item?.id, 1)}
                                  style={{
                                    backgroundColor: "green",
                                    width: 90,
                                    height: 40,
                                    color: "white",
                                  }}
                                >
                                  {t.main.accept}
                                </Button>
                              </div>
                            }
                          </TableCell>
                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(
                                    `/manage-products/details/${item?.id}`
                                  )
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-products/edit/${item.id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <TableContainer className="table_container">
                <Table sx={{ minWidth: 650 }} aria-label="sub-category table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      <TableCell>{t.main.image}</TableCell>
                      <TableCell>{t.main.productName}</TableCell>
                      <TableCell>{t.main.vendorName}</TableCell>
                      <TableCell>{t.main.subCategoryName}</TableCell>
                      <TableCell>{t.main.parentCategory}</TableCell>
                      <TableCell>{t.main.status}</TableCell>
                      <TableCell>{t.main.manageProduct}</TableCell>
                      <TableCell>{t.main.todayDeals}</TableCell>
                      <TableCell>{t.main.bestDeals}</TableCell>
                      <TableCell>{t.main.actions}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {productsData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                          {t.error.noData}
                        </TableCell>
                      </TableRow>
                    ) : (
                      productsData?.map((item, index) => (
                        <TableRow key={item?.id}>
                          <TableCell align="center">
                            {(page - 1) * limit + index + 1}
                          </TableCell>
                          <TableCell>
                            <img
                              style={{
                                borderRadius: "50%",
                                width: 50,
                                height: 50,
                              }}
                              src={item?.product_image?.[0]?.media_url}
                              alt={item?.product_name || ""}
                            />
                          </TableCell>
                          <TableCell>{item?.product_name || ""}</TableCell>
                          <TableCell>{item?.company_name || ""}</TableCell>
                          <TableCell>{item.sub_category || ""}</TableCell>
                          <TableCell>{item?.category || ""}</TableCell>
                          <TableCell>
                            <Switch
                              defaultChecked={item?.is_active}
                              onChange={(e) => {
                                const isChecked = !e.target.checked;
                                changeUserStatus(item?.id, !isChecked);
                              }}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            {
                              <div
                                style={{
                                  justifyContent: "center",
                                  display: "flex",
                                }}
                              >
                                <Button
                                  value="Reject"
                                  onClick={() => {
                                    setSelectedProductId(item?.id);
                                    setRejectOpen(true);
                                  }}
                                  style={{
                                    backgroundColor: "red",
                                    width: 90,
                                    height: 40,
                                    color: "white",
                                  }}
                                >
                                  {t.main.reject}
                                </Button>
                              </div>
                            }
                          </TableCell>
                          <TableCell>
                            <Checkbox
                              checked={item?.today_deal}
                              onChange={() =>
                                updateBestProduct(
                                  item?.id,
                                  !item?.today_deal,
                                  1
                                )
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <Checkbox
                              checked={item?.daily_best_product}
                              onChange={() =>
                                updateBestProduct(
                                  item?.id,
                                  !item?.daily_best_product,
                                  2
                                )
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(
                                    `/manage-products/details/${item?.id}`
                                  )
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-products/edit/${item.id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <TableContainer className="table_container">
                <Table sx={{ minWidth: 650 }} aria-label="sub-category table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      <TableCell>{t.main.image}</TableCell>
                      <TableCell>{t.main.productName}</TableCell>
                      <TableCell>{t.main.vendorName}</TableCell>
                      <TableCell>{t.main.subCategoryName}</TableCell>
                      <TableCell>{t.main.parentCategory}</TableCell>
                      <TableCell>{t.main.actions}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {productsData?.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                          {t.error.noData}
                        </TableCell>
                      </TableRow>
                    ) : (
                      productsData?.map((item, index) => (
                        <TableRow key={item?.id}>
                          <TableCell align="center">
                            {(page - 1) * limit + index + 1}
                          </TableCell>
                          <TableCell>
                            <img
                              style={{
                                borderRadius: "50%",
                                width: 50,
                                height: 50,
                              }}
                              src={item?.product_image[0]?.media_url || ""}
                              alt={item?.product_name || ""}
                            />
                          </TableCell>
                          <TableCell>{item?.product_name || ""}</TableCell>
                          <TableCell>{item?.company_name || ""}</TableCell>
                          <TableCell>{item?.sub_category || ""}</TableCell>
                          <TableCell>{item?.category}</TableCell>
                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() =>
                                  navigate(
                                    `/manage-products/details/${item?.id}`
                                  )
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-products/edit/${item.id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </CustomTabPanel>
          </Box>
        </Card>

        {productsData?.length > 0 ? (
          <Pagination
            setPage={setPage}
            module={productsData}
            page={page}
            onPageChange={setPage}
            totalPages={totalPages}
            setTotalPages={setTotalPages}
            limit={limit}
            setLimit={setLimit}
            totalRecords={totalRecords}
          />
        ) : (
          ""
        )}
      </div>

      <RejectModal
        open={rejectOpen}
        setOpen={setRejectOpen}
        handleDelete={() => {
          ApproveReject(selectedProductId, 2);
        }}
        name="Product"
      />
    </div>
  );
};

export default ManageProduct;
